@if (isAllSelectedOptions) {
  <h2 class="filter-title">Select {{ filterTitle | toPlural }}</h2>
}
@if (!isAllSelectedOptions) {
  <h2 class="filter-title">{{ filterTitle }}</h2>
}
<section class="section-container">
  <span tabindex="0" (keyup.enter)="$event.target.querySelector('input')?.click()" aria-label="All benefit plans">
    @if (isAllSelectedOptions) {
      <mat-checkbox class="filter-checkbox" name="categoryCheck" (change)="onSelectAll($event)" data-cy="select-all-checkbox" [checked]="allSelect" tabindex="0"> All {{ filterTitle | toPlural }} </mat-checkbox>
    }
  </span>
  @if (categoryOptions) {
    <form [formGroup]="categoryForm">
      @for (item of categoryOptions; track item; let i = $index) {
        <span tabindex="0" (keyup.enter)="$event.target.querySelector('input')?.click()" data-cy="class-name-label" attr.aria-label="{{ item.name }}">
          <mat-checkbox data-cy="checkbox-template-category" [attr.data-cy-checkbox-template-id]="i" class="filter-checkbox" name="categoryCheck" (change)="onValueChange($event, i, item)" id="option_{{ i + 1 }}" [checked]="arr[i]" tabindex="0">
            {{ item.name }}
          </mat-checkbox>
        </span>
      }
    </form>
  }
</section>
